/* tslint:disable */
/* eslint-disable */
/**
 * Europrocurement Api Mail
 * API d\'envoi de mails
 *
 * The version of the OpenAPI document: 1.3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface MailAttachmentJsonldMailRead
 */
export interface MailAttachmentJsonldMailRead {
    /**
     * 
     * @type {MailJsonldMailReadContext}
     * @memberof MailAttachmentJsonldMailRead
     */
    '@context'?: MailJsonldMailReadContext;
    /**
     * 
     * @type {string}
     * @memberof MailAttachmentJsonldMailRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailAttachmentJsonldMailRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailAttachmentJsonldMailRead
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailAttachmentJsonldMailRead
     */
    'contentUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailAttachmentJsonldMailRead
     */
    'urlExpires'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailAttachmentJsonldMailRead
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MailAttachmentJsonldMailRead
     */
    'size'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MailAttachmentJsonldMailRead
     */
    'originalName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailAttachmentJsonldMailRead
     */
    'mimeType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MailAttachmentJsonldMailRead
     */
    'deleted'?: boolean;
}
/**
 * 
 * @export
 * @interface MailAttachmentMailRead
 */
export interface MailAttachmentMailRead {
    /**
     * 
     * @type {string}
     * @memberof MailAttachmentMailRead
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailAttachmentMailRead
     */
    'contentUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailAttachmentMailRead
     */
    'urlExpires'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailAttachmentMailRead
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MailAttachmentMailRead
     */
    'size'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MailAttachmentMailRead
     */
    'originalName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailAttachmentMailRead
     */
    'mimeType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MailAttachmentMailRead
     */
    'deleted'?: boolean;
}
/**
 * 
 * @export
 * @interface MailJsonldMailRead
 */
export interface MailJsonldMailRead {
    /**
     * 
     * @type {string}
     * @memberof MailJsonldMailRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailJsonldMailRead
     */
    '@type'?: string;
    /**
     * 
     * @type {MailJsonldMailReadContext}
     * @memberof MailJsonldMailRead
     */
    '@context'?: MailJsonldMailReadContext;
    /**
     * 
     * @type {string}
     * @memberof MailJsonldMailRead
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailJsonldMailRead
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof MailJsonldMailRead
     */
    'fromName'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailJsonldMailRead
     */
    'tos': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailJsonldMailRead
     */
    'ccs': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailJsonldMailRead
     */
    'bccs': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailJsonldMailRead
     */
    'replies': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof MailJsonldMailRead
     */
    'subject': string | null;
    /**
     * 
     * @type {string}
     * @memberof MailJsonldMailRead
     */
    'body': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailJsonldMailRead
     */
    'tags': Array<string> | null;
    /**
     * 
     * @type {Array<MailAttachmentJsonldMailRead>}
     * @memberof MailJsonldMailRead
     */
    'attachments'?: Array<MailAttachmentJsonldMailRead>;
    /**
     * 
     * @type {string}
     * @memberof MailJsonldMailRead
     */
    'status'?: string | null;
}
/**
 * @type MailJsonldMailReadContext
 * @export
 */
export type MailJsonldMailReadContext = MailJsonldMailReadContextOneOf | string;

/**
 * 
 * @export
 * @interface MailJsonldMailReadContextOneOf
 */
export interface MailJsonldMailReadContextOneOf {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof MailJsonldMailReadContextOneOf
     */
    '@vocab': string;
    /**
     * 
     * @type {string}
     * @memberof MailJsonldMailReadContextOneOf
     */
    'hydra': MailJsonldMailReadContextOneOfHydraEnum;
}

export const MailJsonldMailReadContextOneOfHydraEnum = {
    HttpWwwW3OrgNsHydraCore: 'http://www.w3.org/ns/hydra/core#'
} as const;

export type MailJsonldMailReadContextOneOfHydraEnum = typeof MailJsonldMailReadContextOneOfHydraEnum[keyof typeof MailJsonldMailReadContextOneOfHydraEnum];

/**
 * 
 * @export
 * @interface MailJsonldMailSend
 */
export interface MailJsonldMailSend {
    /**
     * 
     * @type {MailJsonldMailReadContext}
     * @memberof MailJsonldMailSend
     */
    '@context'?: MailJsonldMailReadContext;
    /**
     * 
     * @type {string}
     * @memberof MailJsonldMailSend
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailJsonldMailSend
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailJsonldMailSend
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof MailJsonldMailSend
     */
    'fromName'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailJsonldMailSend
     */
    'tos': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailJsonldMailSend
     */
    'ccs': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailJsonldMailSend
     */
    'bccs': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailJsonldMailSend
     */
    'replies': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof MailJsonldMailSend
     */
    'subject': string | null;
    /**
     * 
     * @type {string}
     * @memberof MailJsonldMailSend
     */
    'body': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailJsonldMailSend
     */
    'tags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof MailJsonldMailSend
     */
    'status'?: string | null;
}
/**
 * 
 * @export
 * @interface MailMailRead
 */
export interface MailMailRead {
    /**
     * 
     * @type {string}
     * @memberof MailMailRead
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailMailRead
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof MailMailRead
     */
    'fromName'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailMailRead
     */
    'tos': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailMailRead
     */
    'ccs': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailMailRead
     */
    'bccs': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailMailRead
     */
    'replies': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof MailMailRead
     */
    'subject': string | null;
    /**
     * 
     * @type {string}
     * @memberof MailMailRead
     */
    'body': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailMailRead
     */
    'tags': Array<string> | null;
    /**
     * 
     * @type {Array<MailAttachmentMailRead>}
     * @memberof MailMailRead
     */
    'attachments'?: Array<MailAttachmentMailRead>;
    /**
     * 
     * @type {string}
     * @memberof MailMailRead
     */
    'status'?: string | null;
}
/**
 * 
 * @export
 * @interface MailMailSend
 */
export interface MailMailSend {
    /**
     * 
     * @type {string}
     * @memberof MailMailSend
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof MailMailSend
     */
    'fromName'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailMailSend
     */
    'tos': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailMailSend
     */
    'ccs': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailMailSend
     */
    'bccs': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailMailSend
     */
    'replies': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof MailMailSend
     */
    'subject': string | null;
    /**
     * 
     * @type {string}
     * @memberof MailMailSend
     */
    'body': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailMailSend
     */
    'tags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof MailMailSend
     */
    'status'?: string | null;
}
/**
 * 
 * @export
 * @interface SendQueuedMailsMailCollection200Response
 */
export interface SendQueuedMailsMailCollection200Response {
    /**
     * 
     * @type {string}
     * @memberof SendQueuedMailsMailCollection200Response
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof SendQueuedMailsMailCollection200Response
     */
    'total_sent'?: number;
    /**
     * 
     * @type {number}
     * @memberof SendQueuedMailsMailCollection200Response
     */
    'total_errors'?: number;
}
/**
 * 
 * @export
 * @interface SendQueuedMailsMailCollection500Response
 */
export interface SendQueuedMailsMailCollection500Response {
    /**
     * 
     * @type {string}
     * @memberof SendQueuedMailsMailCollection500Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface UpdateMailBodyMailCollection200Response
 */
export interface UpdateMailBodyMailCollection200Response {
    /**
     * 
     * @type {Array<MailJsonldMailRead>}
     * @memberof UpdateMailBodyMailCollection200Response
     */
    'hydra:member': Array<MailJsonldMailRead>;
    /**
     * 
     * @type {number}
     * @memberof UpdateMailBodyMailCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {UpdateMailBodyMailCollection200ResponseHydraView}
     * @memberof UpdateMailBodyMailCollection200Response
     */
    'hydra:view'?: UpdateMailBodyMailCollection200ResponseHydraView;
    /**
     * 
     * @type {UpdateMailBodyMailCollection200ResponseHydraSearch}
     * @memberof UpdateMailBodyMailCollection200Response
     */
    'hydra:search'?: UpdateMailBodyMailCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface UpdateMailBodyMailCollection200ResponseHydraSearch
 */
export interface UpdateMailBodyMailCollection200ResponseHydraSearch {
    /**
     * 
     * @type {string}
     * @memberof UpdateMailBodyMailCollection200ResponseHydraSearch
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMailBodyMailCollection200ResponseHydraSearch
     */
    'hydra:template'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMailBodyMailCollection200ResponseHydraSearch
     */
    'hydra:variableRepresentation'?: string;
    /**
     * 
     * @type {Array<UpdateMailBodyMailCollection200ResponseHydraSearchHydraMappingInner>}
     * @memberof UpdateMailBodyMailCollection200ResponseHydraSearch
     */
    'hydra:mapping'?: Array<UpdateMailBodyMailCollection200ResponseHydraSearchHydraMappingInner>;
}
/**
 * 
 * @export
 * @interface UpdateMailBodyMailCollection200ResponseHydraSearchHydraMappingInner
 */
export interface UpdateMailBodyMailCollection200ResponseHydraSearchHydraMappingInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateMailBodyMailCollection200ResponseHydraSearchHydraMappingInner
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMailBodyMailCollection200ResponseHydraSearchHydraMappingInner
     */
    'variable'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMailBodyMailCollection200ResponseHydraSearchHydraMappingInner
     */
    'property'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMailBodyMailCollection200ResponseHydraSearchHydraMappingInner
     */
    'required'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateMailBodyMailCollection200ResponseHydraView
 */
export interface UpdateMailBodyMailCollection200ResponseHydraView {
    /**
     * 
     * @type {string}
     * @memberof UpdateMailBodyMailCollection200ResponseHydraView
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMailBodyMailCollection200ResponseHydraView
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMailBodyMailCollection200ResponseHydraView
     */
    'hydra:first'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMailBodyMailCollection200ResponseHydraView
     */
    'hydra:last'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMailBodyMailCollection200ResponseHydraView
     */
    'hydra:previous'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMailBodyMailCollection200ResponseHydraView
     */
    'hydra:next'?: string;
}
/**
 * 
 * @export
 * @interface UpdateMailBodyMailCollectionRequest
 */
export interface UpdateMailBodyMailCollectionRequest {
    /**
     * Nouveau contenu HTML du mail
     * @type {string}
     * @memberof UpdateMailBodyMailCollectionRequest
     */
    'body'?: string;
}

/**
 * MailApi - axios parameter creator
 * @export
 */
export const MailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the Mail resource.
         * @summary Removes the Mail resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMailItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteMailItem', 'id', id)
            const localVarPath = `/mail/mails/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes a mail entry from DynamoDB based on its ID.
         * @summary Delete a queued mail
         * @param {string} id The unique identifier of the mail to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQueuedMailMailCollection: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteQueuedMailMailCollection', 'id', id)
            const localVarPath = `/mail/delete-queued-mail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of Mail resources.
         * @summary Récupère les détails d\'un mail
         * @param {string} id ID du mail à récupérer
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailByIdMailCollection: async (id: string, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMailByIdMailCollection', 'id', id)
            const localVarPath = `/mail/mail-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Mail resource.
         * @summary Retrieves a Mail resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMailItem', 'id', id)
            const localVarPath = `/mail/mails/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the Mail resource.
         * @summary Updates the Mail resource.
         * @param {string} id Resource identifier
         * @param {MailMailSend} mailMailSend The updated Mail resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMailItem: async (id: string, mailMailSend: MailMailSend, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchMailItem', 'id', id)
            // verify required parameter 'mailMailSend' is not null or undefined
            assertParamExists('patchMailItem', 'mailMailSend', mailMailSend)
            const localVarPath = `/mail/mails/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mailMailSend, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the Mail resource.
         * @summary Replaces the Mail resource.
         * @param {string} id Resource identifier
         * @param {MailJsonldMailSend} mailJsonldMailSend The updated Mail resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMailItem: async (id: string, mailJsonldMailSend: MailJsonldMailSend, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putMailItem', 'id', id)
            // verify required parameter 'mailJsonldMailSend' is not null or undefined
            assertParamExists('putMailItem', 'mailJsonldMailSend', mailJsonldMailSend)
            const localVarPath = `/mail/mails/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mailJsonldMailSend, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of Mail resources.
         * @summary Récupérer la liste des mails en attente
         * @param {Array<QueuedMailsMailCollectionStatusesEnum>} [statuses] Statuts des mails à remonter
         * @param {Array<string>} [tags] Liste des tags pour filtrer les mails
         * @param {QueuedMailsMailCollectionOrderIdEnum} [orderId] Trier par ID (asc ou desc)
         * @param {QueuedMailsMailCollectionOrderStatusEnum} [orderStatus] Trier par statut (asc ou desc)
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queuedMailsMailCollection: async (statuses?: Array<QueuedMailsMailCollectionStatusesEnum>, tags?: Array<string>, orderId?: QueuedMailsMailCollectionOrderIdEnum, orderStatus?: QueuedMailsMailCollectionOrderStatusEnum, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/mail/queued-mails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses.join(COLLECTION_FORMATS.csv);
            }

            if (tags) {
                localVarQueryParameter['tags'] = tags.join(COLLECTION_FORMATS.csv);
            }

            if (orderId !== undefined) {
                localVarQueryParameter['order[id]'] = orderId;
            }

            if (orderStatus !== undefined) {
                localVarQueryParameter['order[status]'] = orderStatus;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Click the link to view the rendered HTML template in a new browser window.
         * @summary Render a Twig template
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renderTemplateMailCollection: async (page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/mail/render-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a synchronous e-mail by directly setting up mailer, then send e-mail and finally register a new entry in DynamoDB.
         * @summary Send a synchronous e-mail
         * @param {MailMailSend} [details] 
         * @param {File} [attachments] Single attachment file. Use this field for a single attachment.
         * @param {Array<File>} [attachments2] Alternative approach: Multiple attachments as an array (if supported by client)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMailMailCollection: async (details?: MailMailSend, attachments?: File, attachments2?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/mail/send-mail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


            if (details !== undefined) { 
                localVarFormParams.append('details', new Blob([JSON.stringify(details)], { type: "application/json", }));
            }
    
            if (attachments !== undefined) { 
                localVarFormParams.append('attachments', attachments as any);
            }
                if (attachments2) {
                attachments2.forEach((element) => {
                    localVarFormParams.append('attachments[]', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Processes and sends all pending mails in the queue. Optionally supports parallel processing via AWS Lambda.
         * @summary Send all queued mails
         * @param {boolean} [parallelProcessing] Set to \&#39;true\&#39; to enable AWS Lambda parallel execution. Default is \&#39;false\&#39;.
         * @param {Array<string>} [tags] Tags to filter mails for sending. Only mails containing ALL specified tags will be processed.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendQueuedMailsMailCollection: async (parallelProcessing?: boolean, tags?: Array<string>, page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/mail/send-queued-mails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (parallelProcessing !== undefined) {
                localVarQueryParameter['parallelProcessing'] = parallelProcessing;
            }

            if (tags) {
                localVarQueryParameter['tags'] = tags.join(COLLECTION_FORMATS.csv);
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add an e-mail to the queue by defining a status to \'pending\'.
         * @summary Add an e-mail to the queue
         * @param {MailMailSend} [details] 
         * @param {Array<File>} [attachments] Attachments list, you must name them attachments0, attachments1, etc.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendToQueueMailCollection: async (details?: MailMailSend, attachments?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/mail/send-to-queue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


            if (details !== undefined) { 
                localVarFormParams.append('details', new Blob([JSON.stringify(details)], { type: "application/json", }));
            }
                if (attachments) {
                attachments.forEach((element) => {
                    localVarFormParams.append('attachments', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes a mail entry from DynamoDB based on its ID.
         * @summary Met à jour le contenu d\'un mail
         * @param {string} id ID du mail à mettre à jour
         * @param {UpdateMailBodyMailCollectionRequest} [updateMailBodyMailCollectionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMailBodyMailCollection: async (id: string, updateMailBodyMailCollectionRequest?: UpdateMailBodyMailCollectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMailBodyMailCollection', 'id', id)
            const localVarPath = `/mail/body`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMailBodyMailCollectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MailApi - functional programming interface
 * @export
 */
export const MailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MailApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the Mail resource.
         * @summary Removes the Mail resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMailItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMailItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApi.deleteMailItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes a mail entry from DynamoDB based on its ID.
         * @summary Delete a queued mail
         * @param {string} id The unique identifier of the mail to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteQueuedMailMailCollection(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteQueuedMailMailCollection(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApi.deleteQueuedMailMailCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of Mail resources.
         * @summary Récupère les détails d\'un mail
         * @param {string} id ID du mail à récupérer
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMailByIdMailCollection(id: string, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMailBodyMailCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMailByIdMailCollection(id, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApi.getMailByIdMailCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a Mail resource.
         * @summary Retrieves a Mail resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMailItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MailJsonldMailRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMailItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApi.getMailItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the Mail resource.
         * @summary Updates the Mail resource.
         * @param {string} id Resource identifier
         * @param {MailMailSend} mailMailSend The updated Mail resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchMailItem(id: string, mailMailSend: MailMailSend, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MailJsonldMailRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchMailItem(id, mailMailSend, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApi.patchMailItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the Mail resource.
         * @summary Replaces the Mail resource.
         * @param {string} id Resource identifier
         * @param {MailJsonldMailSend} mailJsonldMailSend The updated Mail resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putMailItem(id: string, mailJsonldMailSend: MailJsonldMailSend, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MailJsonldMailRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putMailItem(id, mailJsonldMailSend, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApi.putMailItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of Mail resources.
         * @summary Récupérer la liste des mails en attente
         * @param {Array<QueuedMailsMailCollectionStatusesEnum>} [statuses] Statuts des mails à remonter
         * @param {Array<string>} [tags] Liste des tags pour filtrer les mails
         * @param {QueuedMailsMailCollectionOrderIdEnum} [orderId] Trier par ID (asc ou desc)
         * @param {QueuedMailsMailCollectionOrderStatusEnum} [orderStatus] Trier par statut (asc ou desc)
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queuedMailsMailCollection(statuses?: Array<QueuedMailsMailCollectionStatusesEnum>, tags?: Array<string>, orderId?: QueuedMailsMailCollectionOrderIdEnum, orderStatus?: QueuedMailsMailCollectionOrderStatusEnum, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMailBodyMailCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queuedMailsMailCollection(statuses, tags, orderId, orderStatus, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApi.queuedMailsMailCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Click the link to view the rendered HTML template in a new browser window.
         * @summary Render a Twig template
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renderTemplateMailCollection(page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMailBodyMailCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renderTemplateMailCollection(page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApi.renderTemplateMailCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send a synchronous e-mail by directly setting up mailer, then send e-mail and finally register a new entry in DynamoDB.
         * @summary Send a synchronous e-mail
         * @param {MailMailSend} [details] 
         * @param {File} [attachments] Single attachment file. Use this field for a single attachment.
         * @param {Array<File>} [attachments2] Alternative approach: Multiple attachments as an array (if supported by client)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMailMailCollection(details?: MailMailSend, attachments?: File, attachments2?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MailJsonldMailRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMailMailCollection(details, attachments, attachments2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApi.sendMailMailCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Processes and sends all pending mails in the queue. Optionally supports parallel processing via AWS Lambda.
         * @summary Send all queued mails
         * @param {boolean} [parallelProcessing] Set to \&#39;true\&#39; to enable AWS Lambda parallel execution. Default is \&#39;false\&#39;.
         * @param {Array<string>} [tags] Tags to filter mails for sending. Only mails containing ALL specified tags will be processed.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendQueuedMailsMailCollection(parallelProcessing?: boolean, tags?: Array<string>, page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendQueuedMailsMailCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendQueuedMailsMailCollection(parallelProcessing, tags, page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApi.sendQueuedMailsMailCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add an e-mail to the queue by defining a status to \'pending\'.
         * @summary Add an e-mail to the queue
         * @param {MailMailSend} [details] 
         * @param {Array<File>} [attachments] Attachments list, you must name them attachments0, attachments1, etc.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendToQueueMailCollection(details?: MailMailSend, attachments?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MailJsonldMailRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendToQueueMailCollection(details, attachments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApi.sendToQueueMailCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes a mail entry from DynamoDB based on its ID.
         * @summary Met à jour le contenu d\'un mail
         * @param {string} id ID du mail à mettre à jour
         * @param {UpdateMailBodyMailCollectionRequest} [updateMailBodyMailCollectionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMailBodyMailCollection(id: string, updateMailBodyMailCollectionRequest?: UpdateMailBodyMailCollectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMailBodyMailCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMailBodyMailCollection(id, updateMailBodyMailCollectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MailApi.updateMailBodyMailCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MailApi - factory interface
 * @export
 */
export const MailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MailApiFp(configuration)
    return {
        /**
         * Removes the Mail resource.
         * @summary Removes the Mail resource.
         * @param {MailApiDeleteMailItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMailItem(requestParameters: MailApiDeleteMailItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMailItem(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes a mail entry from DynamoDB based on its ID.
         * @summary Delete a queued mail
         * @param {MailApiDeleteQueuedMailMailCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQueuedMailMailCollection(requestParameters: MailApiDeleteQueuedMailMailCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteQueuedMailMailCollection(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of Mail resources.
         * @summary Récupère les détails d\'un mail
         * @param {MailApiGetMailByIdMailCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailByIdMailCollection(requestParameters: MailApiGetMailByIdMailCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateMailBodyMailCollection200Response> {
            return localVarFp.getMailByIdMailCollection(requestParameters.id, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Mail resource.
         * @summary Retrieves a Mail resource.
         * @param {MailApiGetMailItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailItem(requestParameters: MailApiGetMailItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<MailJsonldMailRead> {
            return localVarFp.getMailItem(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the Mail resource.
         * @summary Updates the Mail resource.
         * @param {MailApiPatchMailItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMailItem(requestParameters: MailApiPatchMailItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<MailJsonldMailRead> {
            return localVarFp.patchMailItem(requestParameters.id, requestParameters.mailMailSend, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the Mail resource.
         * @summary Replaces the Mail resource.
         * @param {MailApiPutMailItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMailItem(requestParameters: MailApiPutMailItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<MailJsonldMailRead> {
            return localVarFp.putMailItem(requestParameters.id, requestParameters.mailJsonldMailSend, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of Mail resources.
         * @summary Récupérer la liste des mails en attente
         * @param {MailApiQueuedMailsMailCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queuedMailsMailCollection(requestParameters: MailApiQueuedMailsMailCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UpdateMailBodyMailCollection200Response> {
            return localVarFp.queuedMailsMailCollection(requestParameters.statuses, requestParameters.tags, requestParameters.orderId, requestParameters.orderStatus, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Click the link to view the rendered HTML template in a new browser window.
         * @summary Render a Twig template
         * @param {MailApiRenderTemplateMailCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renderTemplateMailCollection(requestParameters: MailApiRenderTemplateMailCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UpdateMailBodyMailCollection200Response> {
            return localVarFp.renderTemplateMailCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Send a synchronous e-mail by directly setting up mailer, then send e-mail and finally register a new entry in DynamoDB.
         * @summary Send a synchronous e-mail
         * @param {MailApiSendMailMailCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMailMailCollection(requestParameters: MailApiSendMailMailCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<MailJsonldMailRead> {
            return localVarFp.sendMailMailCollection(requestParameters.details, requestParameters.attachments, requestParameters.attachments2, options).then((request) => request(axios, basePath));
        },
        /**
         * Processes and sends all pending mails in the queue. Optionally supports parallel processing via AWS Lambda.
         * @summary Send all queued mails
         * @param {MailApiSendQueuedMailsMailCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendQueuedMailsMailCollection(requestParameters: MailApiSendQueuedMailsMailCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SendQueuedMailsMailCollection200Response> {
            return localVarFp.sendQueuedMailsMailCollection(requestParameters.parallelProcessing, requestParameters.tags, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Add an e-mail to the queue by defining a status to \'pending\'.
         * @summary Add an e-mail to the queue
         * @param {MailApiSendToQueueMailCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendToQueueMailCollection(requestParameters: MailApiSendToQueueMailCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<MailJsonldMailRead> {
            return localVarFp.sendToQueueMailCollection(requestParameters.details, requestParameters.attachments, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes a mail entry from DynamoDB based on its ID.
         * @summary Met à jour le contenu d\'un mail
         * @param {MailApiUpdateMailBodyMailCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMailBodyMailCollection(requestParameters: MailApiUpdateMailBodyMailCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateMailBodyMailCollection200Response> {
            return localVarFp.updateMailBodyMailCollection(requestParameters.id, requestParameters.updateMailBodyMailCollectionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteMailItem operation in MailApi.
 * @export
 * @interface MailApiDeleteMailItemRequest
 */
export interface MailApiDeleteMailItemRequest {
    /**
     * Resource identifier
     * @type {string}
     * @memberof MailApiDeleteMailItem
     */
    readonly id: string
}

/**
 * Request parameters for deleteQueuedMailMailCollection operation in MailApi.
 * @export
 * @interface MailApiDeleteQueuedMailMailCollectionRequest
 */
export interface MailApiDeleteQueuedMailMailCollectionRequest {
    /**
     * The unique identifier of the mail to delete.
     * @type {string}
     * @memberof MailApiDeleteQueuedMailMailCollection
     */
    readonly id: string
}

/**
 * Request parameters for getMailByIdMailCollection operation in MailApi.
 * @export
 * @interface MailApiGetMailByIdMailCollectionRequest
 */
export interface MailApiGetMailByIdMailCollectionRequest {
    /**
     * ID du mail à récupérer
     * @type {string}
     * @memberof MailApiGetMailByIdMailCollection
     */
    readonly id: string

    /**
     * The collection page number
     * @type {number}
     * @memberof MailApiGetMailByIdMailCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof MailApiGetMailByIdMailCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for getMailItem operation in MailApi.
 * @export
 * @interface MailApiGetMailItemRequest
 */
export interface MailApiGetMailItemRequest {
    /**
     * Resource identifier
     * @type {string}
     * @memberof MailApiGetMailItem
     */
    readonly id: string
}

/**
 * Request parameters for patchMailItem operation in MailApi.
 * @export
 * @interface MailApiPatchMailItemRequest
 */
export interface MailApiPatchMailItemRequest {
    /**
     * Resource identifier
     * @type {string}
     * @memberof MailApiPatchMailItem
     */
    readonly id: string

    /**
     * The updated Mail resource
     * @type {MailMailSend}
     * @memberof MailApiPatchMailItem
     */
    readonly mailMailSend: MailMailSend
}

/**
 * Request parameters for putMailItem operation in MailApi.
 * @export
 * @interface MailApiPutMailItemRequest
 */
export interface MailApiPutMailItemRequest {
    /**
     * Resource identifier
     * @type {string}
     * @memberof MailApiPutMailItem
     */
    readonly id: string

    /**
     * The updated Mail resource
     * @type {MailJsonldMailSend}
     * @memberof MailApiPutMailItem
     */
    readonly mailJsonldMailSend: MailJsonldMailSend
}

/**
 * Request parameters for queuedMailsMailCollection operation in MailApi.
 * @export
 * @interface MailApiQueuedMailsMailCollectionRequest
 */
export interface MailApiQueuedMailsMailCollectionRequest {
    /**
     * Statuts des mails à remonter
     * @type {Array<'pending' | 'sent' | 'error'>}
     * @memberof MailApiQueuedMailsMailCollection
     */
    readonly statuses?: Array<QueuedMailsMailCollectionStatusesEnum>

    /**
     * Liste des tags pour filtrer les mails
     * @type {Array<string>}
     * @memberof MailApiQueuedMailsMailCollection
     */
    readonly tags?: Array<string>

    /**
     * Trier par ID (asc ou desc)
     * @type {'asc' | 'desc'}
     * @memberof MailApiQueuedMailsMailCollection
     */
    readonly orderId?: QueuedMailsMailCollectionOrderIdEnum

    /**
     * Trier par statut (asc ou desc)
     * @type {'asc' | 'desc'}
     * @memberof MailApiQueuedMailsMailCollection
     */
    readonly orderStatus?: QueuedMailsMailCollectionOrderStatusEnum

    /**
     * The collection page number
     * @type {number}
     * @memberof MailApiQueuedMailsMailCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof MailApiQueuedMailsMailCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for renderTemplateMailCollection operation in MailApi.
 * @export
 * @interface MailApiRenderTemplateMailCollectionRequest
 */
export interface MailApiRenderTemplateMailCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof MailApiRenderTemplateMailCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof MailApiRenderTemplateMailCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for sendMailMailCollection operation in MailApi.
 * @export
 * @interface MailApiSendMailMailCollectionRequest
 */
export interface MailApiSendMailMailCollectionRequest {
    /**
     * 
     * @type {MailMailSend}
     * @memberof MailApiSendMailMailCollection
     */
    readonly details?: MailMailSend

    /**
     * Single attachment file. Use this field for a single attachment.
     * @type {File}
     * @memberof MailApiSendMailMailCollection
     */
    readonly attachments?: File

    /**
     * Alternative approach: Multiple attachments as an array (if supported by client)
     * @type {Array<File>}
     * @memberof MailApiSendMailMailCollection
     */
    readonly attachments2?: Array<File>
}

/**
 * Request parameters for sendQueuedMailsMailCollection operation in MailApi.
 * @export
 * @interface MailApiSendQueuedMailsMailCollectionRequest
 */
export interface MailApiSendQueuedMailsMailCollectionRequest {
    /**
     * Set to \&#39;true\&#39; to enable AWS Lambda parallel execution. Default is \&#39;false\&#39;.
     * @type {boolean}
     * @memberof MailApiSendQueuedMailsMailCollection
     */
    readonly parallelProcessing?: boolean

    /**
     * Tags to filter mails for sending. Only mails containing ALL specified tags will be processed.
     * @type {Array<string>}
     * @memberof MailApiSendQueuedMailsMailCollection
     */
    readonly tags?: Array<string>

    /**
     * The collection page number
     * @type {number}
     * @memberof MailApiSendQueuedMailsMailCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof MailApiSendQueuedMailsMailCollection
     */
    readonly itemsPerPage?: number
}

/**
 * Request parameters for sendToQueueMailCollection operation in MailApi.
 * @export
 * @interface MailApiSendToQueueMailCollectionRequest
 */
export interface MailApiSendToQueueMailCollectionRequest {
    /**
     * 
     * @type {MailMailSend}
     * @memberof MailApiSendToQueueMailCollection
     */
    readonly details?: MailMailSend

    /**
     * Attachments list, you must name them attachments0, attachments1, etc.
     * @type {Array<File>}
     * @memberof MailApiSendToQueueMailCollection
     */
    readonly attachments?: Array<File>
}

/**
 * Request parameters for updateMailBodyMailCollection operation in MailApi.
 * @export
 * @interface MailApiUpdateMailBodyMailCollectionRequest
 */
export interface MailApiUpdateMailBodyMailCollectionRequest {
    /**
     * ID du mail à mettre à jour
     * @type {string}
     * @memberof MailApiUpdateMailBodyMailCollection
     */
    readonly id: string

    /**
     * 
     * @type {UpdateMailBodyMailCollectionRequest}
     * @memberof MailApiUpdateMailBodyMailCollection
     */
    readonly updateMailBodyMailCollectionRequest?: UpdateMailBodyMailCollectionRequest
}

/**
 * MailApi - object-oriented interface
 * @export
 * @class MailApi
 * @extends {BaseAPI}
 */
export class MailApi extends BaseAPI {
    /**
     * Removes the Mail resource.
     * @summary Removes the Mail resource.
     * @param {MailApiDeleteMailItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailApi
     */
    public deleteMailItem(requestParameters: MailApiDeleteMailItemRequest, options?: RawAxiosRequestConfig) {
        return MailApiFp(this.configuration).deleteMailItem(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes a mail entry from DynamoDB based on its ID.
     * @summary Delete a queued mail
     * @param {MailApiDeleteQueuedMailMailCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailApi
     */
    public deleteQueuedMailMailCollection(requestParameters: MailApiDeleteQueuedMailMailCollectionRequest, options?: RawAxiosRequestConfig) {
        return MailApiFp(this.configuration).deleteQueuedMailMailCollection(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of Mail resources.
     * @summary Récupère les détails d\'un mail
     * @param {MailApiGetMailByIdMailCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailApi
     */
    public getMailByIdMailCollection(requestParameters: MailApiGetMailByIdMailCollectionRequest, options?: RawAxiosRequestConfig) {
        return MailApiFp(this.configuration).getMailByIdMailCollection(requestParameters.id, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Mail resource.
     * @summary Retrieves a Mail resource.
     * @param {MailApiGetMailItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailApi
     */
    public getMailItem(requestParameters: MailApiGetMailItemRequest, options?: RawAxiosRequestConfig) {
        return MailApiFp(this.configuration).getMailItem(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the Mail resource.
     * @summary Updates the Mail resource.
     * @param {MailApiPatchMailItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailApi
     */
    public patchMailItem(requestParameters: MailApiPatchMailItemRequest, options?: RawAxiosRequestConfig) {
        return MailApiFp(this.configuration).patchMailItem(requestParameters.id, requestParameters.mailMailSend, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the Mail resource.
     * @summary Replaces the Mail resource.
     * @param {MailApiPutMailItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailApi
     */
    public putMailItem(requestParameters: MailApiPutMailItemRequest, options?: RawAxiosRequestConfig) {
        return MailApiFp(this.configuration).putMailItem(requestParameters.id, requestParameters.mailJsonldMailSend, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of Mail resources.
     * @summary Récupérer la liste des mails en attente
     * @param {MailApiQueuedMailsMailCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailApi
     */
    public queuedMailsMailCollection(requestParameters: MailApiQueuedMailsMailCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return MailApiFp(this.configuration).queuedMailsMailCollection(requestParameters.statuses, requestParameters.tags, requestParameters.orderId, requestParameters.orderStatus, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Click the link to view the rendered HTML template in a new browser window.
     * @summary Render a Twig template
     * @param {MailApiRenderTemplateMailCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailApi
     */
    public renderTemplateMailCollection(requestParameters: MailApiRenderTemplateMailCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return MailApiFp(this.configuration).renderTemplateMailCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a synchronous e-mail by directly setting up mailer, then send e-mail and finally register a new entry in DynamoDB.
     * @summary Send a synchronous e-mail
     * @param {MailApiSendMailMailCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailApi
     */
    public sendMailMailCollection(requestParameters: MailApiSendMailMailCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return MailApiFp(this.configuration).sendMailMailCollection(requestParameters.details, requestParameters.attachments, requestParameters.attachments2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Processes and sends all pending mails in the queue. Optionally supports parallel processing via AWS Lambda.
     * @summary Send all queued mails
     * @param {MailApiSendQueuedMailsMailCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailApi
     */
    public sendQueuedMailsMailCollection(requestParameters: MailApiSendQueuedMailsMailCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return MailApiFp(this.configuration).sendQueuedMailsMailCollection(requestParameters.parallelProcessing, requestParameters.tags, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add an e-mail to the queue by defining a status to \'pending\'.
     * @summary Add an e-mail to the queue
     * @param {MailApiSendToQueueMailCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailApi
     */
    public sendToQueueMailCollection(requestParameters: MailApiSendToQueueMailCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return MailApiFp(this.configuration).sendToQueueMailCollection(requestParameters.details, requestParameters.attachments, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes a mail entry from DynamoDB based on its ID.
     * @summary Met à jour le contenu d\'un mail
     * @param {MailApiUpdateMailBodyMailCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailApi
     */
    public updateMailBodyMailCollection(requestParameters: MailApiUpdateMailBodyMailCollectionRequest, options?: RawAxiosRequestConfig) {
        return MailApiFp(this.configuration).updateMailBodyMailCollection(requestParameters.id, requestParameters.updateMailBodyMailCollectionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const QueuedMailsMailCollectionStatusesEnum = {
    Pending: 'pending',
    Sent: 'sent',
    Error: 'error'
} as const;
export type QueuedMailsMailCollectionStatusesEnum = typeof QueuedMailsMailCollectionStatusesEnum[keyof typeof QueuedMailsMailCollectionStatusesEnum];
/**
 * @export
 */
export const QueuedMailsMailCollectionOrderIdEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type QueuedMailsMailCollectionOrderIdEnum = typeof QueuedMailsMailCollectionOrderIdEnum[keyof typeof QueuedMailsMailCollectionOrderIdEnum];
/**
 * @export
 */
export const QueuedMailsMailCollectionOrderStatusEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type QueuedMailsMailCollectionOrderStatusEnum = typeof QueuedMailsMailCollectionOrderStatusEnum[keyof typeof QueuedMailsMailCollectionOrderStatusEnum];


